import { render, staticRenderFns } from "./AttentionBar.vue?vue&type=template&id=27ded336"
import script from "./AttentionBar.vue?vue&type=script&lang=js"
export * from "./AttentionBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports